import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { submitRepresentatives } from "../../auth/services/privateapicalling";
import * as Yup from "yup";
import { toast } from "react-toastify";


interface RepresentativesProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  isRepresentativeFilled:boolean;
  fetchApplicationIfExist: () => Promise<void>;
  existData:any;
  applicationId:string | null;
  
}

interface Representative {
  name: string;
  age: string;
  address: string;
}

const Representatives: React.FC<RepresentativesProps> = ({
  onNext,
  onPrev,
  isRepresentativeFilled,
  fetchApplicationIfExist,
  applicationId,
  existData
}) => {
  //.log('existData rep',existData)
  const token = useSelector((state: any) => state.auth.token);
  const language = useSelector((state:any)=>state.auth.language);
     const formLanguage = useSelector((state: any) => state.auth.formLanguage)
  
   const userdetails = useSelector((state: any) => state.auth.userDetails);
      const applicationIdRedux = useSelector((state:any)=>state.auth.applicationId);
      
    
      const appId= userdetails.applicationId ? userdetails.applicationId: applicationIdRedux


  const [representatives, setRepresentatives] = useState(
    existData?.representatives?.length > 0
      ? existData.representatives
      : [{ name: "", age: "", address: "" }]
  );

     const [isLoading, setIsLoading] = useState(false);
  

  const handleChange = (index: number, field: string, value: string) => {
    const updatedReps = [...representatives];
    updatedReps[index] = { ...updatedReps[index], [field]: value };
    setRepresentatives(updatedReps);
  };

  const handleAddRepresentative = () => {
    setRepresentatives([
      ...representatives,
      { name: "", age: "", address: "" },
    ]);
  };

  const handleRemoveRepresentative = (index: number) => {
    const updatedReps = [...representatives];
    updatedReps.splice(index, 1); // Remove by index
    setRepresentatives(updatedReps);
  };


  const [errors, setErrors] = useState<{ representatives: { name?: string; age?: string; address?: string }[] }>({
    representatives: [],
  });

    const validationSchema = Yup.object().shape({
      representatives: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .matches(/^[A-Za-z\s]+$/, "Only alphabets and spaces are allowed, no special characters")
            .max(40, "Name must not exceed 40 characters including spaces")
            .required("Name is required"),
          age: Yup.number()
            .typeError("Age must be a number")
            .min(1, "Age must be at least 1")
            .max(120, "Age must be less than or equal to 120")
            .required("Age is required"),
            address:  Yup.string().matches( /^[A-Za-z0-9\s+\/'",.\-_@#$%&*()!?:;]+$/,
                "Only alphabets, spaces,numbers and the following special characters are allowed: + / ' , ."
              ).max(100, "Address must not exceed 100 characters")
            .required("Address is required"),
        })
      )
    });


    const validationForm = async () => {
      try {
     
        await validationSchema.validate({ representatives }, { abortEarly: false });
    
        setErrors({ representatives: [] });
      
        return true;
      } catch (err: any) {
       
    
        let newErrors: any = { representatives: representatives.map(() => ({})) };
    
        if (err.inner && err.inner.length > 0) {
          // Multiple validation errors
          err.inner.forEach((error: any) => {
            if (!error.path) return;
    
            const pathParts = error.path.match(/representatives\[(\d+)]\.(\w+)/);
            if (pathParts) {
              const index = parseInt(pathParts[1], 10);
              const field = pathParts[2];
    
              if (!newErrors.representatives[index]) {
                newErrors.representatives[index] = {};
              }
    
              newErrors.representatives[index][field] = error.message;
            }
          });
        } else {
          // Single validation error (not in `inner`)
          if (err.path) {
            const pathParts = err.path.match(/representatives\[(\d+)]\.(\w+)/);
            if (pathParts) {
              const index = parseInt(pathParts[1], 10);
              const field = pathParts[2];
    
              if (!newErrors.representatives[index]) {
                newErrors.representatives[index] = {};
              }
    
              newErrors.representatives[index][field] = err.message;
            }
          }
        }
    
    
        setErrors(newErrors);
        return false;
      }
    };
    
    
    
    
    
  useEffect(() => {
 
  }, [errors]);
 

  const handleSubmit = async () => {
    // onNext("")
    fetchApplicationIfExist();
   
    

    const isValid = await validationForm();
   
    if (!isValid) {
      toast.error("Please enter details before submitting.", {position: "top-right", autoClose: 3000,});
      return;
    }



    const representivedata = {
      applicationId: applicationId,
      representatives: representatives,
      // isRepresentativeFilled: true
    };
    setIsLoading(true);


   

    try {
      const res = await submitRepresentatives(representivedata, token);
      
     

      if (res.success === false) {
        // alert(`${res.message}`);
        toast.error(`${res.message}`, {position: "top-right", autoClose: 3000,});
      } else {
        onNext(representatives);
      }
    } catch (error) {
    
    } finally{
      setIsLoading(false);
    }
  };

    useEffect(()=>{
   
    },[])
  

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">
              {language.representative_details}
            </h6>
          </div>
          <div className="card-body">
            <h4 className="text-info">{formLanguage.representative_heading} ({language.representative_heading})</h4>
            {representatives.map((rep :any, index:number) => (
              
              <div key={index} className="mb-3">
                {/* Name Field */}
                <label className="col-form-label">
                {formLanguage.name} ({language.name}) <span className="text-danger">*</span>
             
                </label>
                <input
                  type="text"
                  className={`form-control ${errors?.representatives?.[index]?.name ? "is-invalid" : ""}`}
                    value={rep.name}
                    onChange={(e) => handleChange(index, "name", e.target.value)}
                  />
                  {errors?.representatives?.[index]?.name && (
                    <div className="d-block invalid-feedback">
                      {errors.representatives[index].name}
                    </div>
                  )}
                  
                <label className="col-form-label">
                {formLanguage.age_in_year} ({language.age_in_year}) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className={`form-control ${errors.representatives?.[index]?.age ? "is-invalid" : ""}`}
                  value={rep.age}
                  onChange={(e) => handleChange(index, "age", e.target.value)}
                  min={0}
                />
               {errors?.representatives?.[index]?.age && (
                    <div className="d-block invalid-feedback">
                      {errors.representatives[index].age}
                    </div>
                  )}

                {/* Address Field */}
                <label className="col-form-label">
                {formLanguage.address} ({language.address}) <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.representatives?.[index]?.address ? "is-invalid" : ""}`}
                  value={rep.address}
                  onChange={(e) => handleChange(index, "address", e.target.value)}
                />
               {errors?.representatives?.[index]?.address && (
                    <div className="d-block invalid-feedback">
                      {errors.representatives[index].address}
                    </div>
                  )}
                {representatives.length > 1 && (
      <button
        type="button"
        className="btn btn-danger mt-2"
        onClick={() => handleRemoveRepresentative(index)}
      >
        {language.delete}
      </button>
    )}
              </div>
            ))}

            {/* {representatives.map((rep, index) => ( */}
              {/* <div className="mb-3"> */}
                {/* Fields */}
                {/* Remove Button */}
                {/* {representatives.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger mt-2"
                    onClick={() => handleRemoveRepresentative}
                  >
                    Remove
                  </button>
                )}
              </div> */}
            {/* ))} */}


          {/* Add Button */}
          <button
            type="button"
            className="btn btn-info rounded-pill mt-3"
            onClick={handleAddRepresentative}
          >
            {language.add}
          </button>

          {/* Navigation Buttons */}
        
            {/* <button
              type="button"
              className="btn btn-secondary me-4"
              onClick={onPrev}
            >
              {language.add}
            </button> */}

            {/* Navigation Buttons */}
            <div className="d-flex justify-content-between mt-3">
              <button
                type="button"
                className="btn btn-secondary me-4"
                onClick={onPrev}
              >
                {language.previous}
              </button>
             
              <button type="button" className="btn btn-primary"  onClick={handleSubmit} disabled={isLoading}>
              {isLoading ? (
                <i className="ion-load-a ion-spin"></i> // Loading spinner
              ) : (
                ` ${language.next}`
              )}
            </button>
          
          </div>
        </div>
      </div>
    </div>
          {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              Submitting...
            </span>
          </div>
        </div>
      )}
  </div>
  );
};

export default Representatives;

